import api from "./api";

const DailyReportService = {
  // CREATE
  create: async (data) => {
    const response = await api.post("/reports/save", data);
    return response.data;
  },

  // GET ALL
  // getAll: async (page = 1, limit = 20) => {
  //   const response = await api.get("/reports/getAll", {
  //     params: {
  //       page,
  //       limit
  //     },
  //   });
  //   return response.data;
  // },

  getAll: async (
    page = 1,
    limit = 20,
    filters = {}
  ) => {

    const response = await api.get(
      "/reports/getAll",
      {
        params: {
          page,
          limit,

          companyId: filters.companyId,
          projectId: filters.projectId,
          locationId: filters.locationId,
          status: filters.status,
          fromDate: filters.fromDate,
          toDate: filters.toDate
        }
      }
    );

    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/reports/getById/${id}`);
    return response.data;
  },

  // GET ACTIVE ONLY
  getActive: async () => {
    const response = await api.get("/reports/getActive/list");
    return response.data;
  },

  // UPDATE
  update: async (id, data) => {
    const response = await api.put(`/reports/update/${id}`, data);
    return response.data;
  },

  // UPDATE STATUS
  updateStatus: async (id) => {
    const response = await api.put(`/reports/updateStatus/${id}`);
    return response.data;
  },

  // DELETE (if needed)
  remove: async (id) => {
    const response = await api.delete(`/reports/${id}`);
    return response.data;
  },

  getByProject: async (projectId) => {
    const response = await api.get(`/reports/getByProject/${projectId}`);
    return response.data;
  },

  approve: async (data) => {
    const response = await api.put(`/reports/approve`, data);
    return response.data;
  },

  reject: async (data) => {
    const response = await api.put(`/reports/reject`, data);
    return response.data;
  },

  cancel: async (data) => {
    const response = await api.put(`/reports/cancel`, data);
    return response.data;
  },

  getApprovedByDate: async (date) => {

    const response = await api.get(`/reports/approvedByDate/${date}`);

    return response.data;

  },

  // GET PROJECT LOCATIONS
  getProjectLocations: async (projectId) => {
    const response = await api.get(
      `/reports/getProjectLocations/${projectId}`
    );

    return response.data;
  },

  getProjectVouchers: (projectId) =>
    api.get(`/reports/vouchers/${projectId}`),

  getProjectStockOutItems: (projectId, locationId) =>
    api.get(`/reports/project-stockout-items/${projectId}/${locationId}`),

  getItemVouchers: (projectId, locationId, itemId, reportDate) =>
    api.get(`/reports/item-vouchers/${projectId}/${locationId}/${itemId}`, {
      params: {
        reportDate
      }
    }),

  getVoucherItems: (voucherNo) =>
    api.get(
      `/reports/voucher-items/${encodeURIComponent(voucherNo)}`
    ),

  getAvailableBalance:
    (voucherNo, itemId) =>

      api.get(
        `/reports/available-balance/${encodeURIComponent(voucherNo)}/${itemId}`
      ),

  getReport: async (id) => {

    const response =
      await api.get(
        `/reports/report/${id}`
      );

    return response.data;

  },

  checkExisting: (
    projectId,
    reportDate,
    locationId
  ) =>
    api.get(
      `/reports/check-existing`,
      {
        params: {
          projectId,
          reportDate,
          locationId
        }
      }
    ),

  checkPending: (
    projectId,
    locationId
  ) =>
    api.get(
      "/reports/check-pending",
      {
        params: {
          projectId,
          locationId
        }
      }
    ),
};



export default DailyReportService;
